import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  get_apiOverride256dzuooesqle as get_apiOverride,
  get_selectedApi2lg32khtf3h6e as get_selectedApi,
} from '../../sdk/apiOptions.mjs';
import {
  await1xlt6i5aa076q as await_0,
  await1uwe8zvsjq69o as await_1,
} from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { Companion_getInstance2o9uk4k3kfl5 as Companion_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/uuid/Uuid.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import {
  get_stringsy7vodl9dj0ya as get_strings,
  StringsForLanguage_English_getInstance2jm5ip12elsyk as StringsForLanguage_English_getInstance,
  StringsForLanguage_Spanish_getInstance352f75oly0h9y as StringsForLanguage_Spanish_getInstance,
  StringsForLanguage_Portuguese_getInstance3vxpdkn8xejqr as StringsForLanguage_Portuguese_getInstance,
} from '../../strings.mjs';
import {
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  AnonymousStart3b856zy9p4ann as AnonymousStart,
  QuestionResponse2c5i2ax2qx74j as QuestionResponse,
  AnonymousAnswers32nmi1m84y0s5 as AnonymousAnswers,
  ID2laazuggebybv as ID,
  isComplete1mj6g5clu144t as isComplete,
  nextTakingDate2z4ej6zmlzj64 as nextTakingDate,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/survey.mjs';
import {
  surveyBody36qk50xkxc85p as surveyBody,
  answersToSubmit2mg7x325t3tua as answersToSubmit,
  get_language3mm5ndad9guf0 as get_language,
  textFor1swo8t3yupnka as textFor,
} from './surveyComponents.mjs';
import { toast4hp3bb4ymp24 as toast } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/popoverHelpers.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  listOfvhqybd2zx248 as listOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import {
  plus2m1vv33moko5t as plus,
  emptyMapr06gerzljqtm as emptyMap,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import {
  Companion_instance1lm8x0jadqh2g as Companion_instance,
  Platform_Web_getInstance2840w5bkfolz8 as Platform_Web_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.mjs';
import { get_current2r182tjucmm5v as get_current } from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.js.mjs';
import {
  Signal1973xs1vkmdcb as Signal,
  _Constant___init__impl__v45mub2qfk15kh5l39c as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { get_scrolling3fwkltztkpfe8 as get_scrolling } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { maxWidth22r11xnm7d4h4 as maxWidth } from '../components/view-utilities.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import {
  ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement,
  Companion_getInstanceztgx4sy4wjnt as Companion_getInstance_0,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { rememberSuspending14xvgr29y3z54 as rememberSuspending } from '../../../../../../reactive/com/lightningkite/reactive/core/RememberSuspending.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import {
  get_centered31th09q7x90sf as get_centered,
  get_atEnd34105oxxaxc2o as get_atEnd,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  weight31wqab1913ly4 as weight,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  HeaderSemantic_getInstance20a9id3sf7d4x as HeaderSemantic_getInstance,
  get_H1Semantic28sytsa4fm6nk as get_H1Semantic,
  SubtextSemantic_getInstance1duu1ll1kgx8d as SubtextSemantic_getInstance,
  FieldSemantic_getInstancer1p3l15xmphu as FieldSemantic_getInstance,
  ButtonSemantic_getInstance3q30xblp6a1af as ButtonSemantic_getInstance,
  CardSemantic_getInstancelcny5le8pbc4 as CardSemantic_getInstance,
  ImportantSemantic_getInstancehm7lt56tp87l as ImportantSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
  FullscreenPage2qcc83o0veqoh as FullscreenPage,
} from '../../App.mjs';
import {
  themed2vu67ornd4jps as themed,
  get_bold3d63kt1t4c9r5 as get_bold,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { Select2osqjs95yxuh6 as Select } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Select.commonHtml.mjs';
import { listOf1jh22dvmctj1r as listOf_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { today1rno4frfjp5oe as today } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/clock.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick3gjrd4jjo1cak as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { replace3le3ie7l9k8aq as replace } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import {
  get_entries2mjjs5oycal4x as get_entries,
  get_entries3tl980hg1b2bm as get_entries_0,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/domain.mjs';
import { RadioButton1rpamcjl5aybg as RadioButton } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/RadioButton.commonHtml.mjs';
import { plus310ted5e4i90h as plus_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  Button$_get_enabled_$ref_61t7nx58ibx9ifxb3n as Button$_get_enabled_$ref_61t7nx,
  Button$_set_enabled_$ref_o8kynzfmpduwei6tot as Button$_set_enabled_$ref_o8kynz,
} from '../applications/FamilyApplicationDetailPage.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import { SwapView1526g6cz7z56r as SwapView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/SwapView.commonHtml.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { Companion_getInstance29ka8gqgdrya1 as Companion_getInstance_1 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/ScreenTransitions.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString30pk9tzaqopn as toString,
  arrayOf1akklvh2at202 as arrayOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { report1vfr9zf0i9d9p as report } from '../../../../../../kiteui-library/com/lightningkite/kiteui/debugger.mjs';
import { reactive2xic0rufq5s8n as reactive } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { Page1o437w9xuocrm as Page } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { PrimitiveClasses_getInstance13wbaztpz3e2d as PrimitiveClasses_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializer1hwzc6m64v1op as serializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/Serializers.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { PersistentProperty2s7ex88zm8bn9 as PersistentProperty } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/PersistentProperty.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_storedTakerId() {
  _init_properties_AnonymousSurveyPage_kt__6juo4k();
  return storedTakerId;
}
var storedTakerId;
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  Stage_Opening_instance = new (Stage())('Opening', 0);
  Stage_Questions_instance = new (Stage())('Questions', 1);
  Stage_Completed_instance = new (Stage())('Completed', 2);
}
var Stage_Opening_instance;
var Stage_Questions_instance;
var Stage_Completed_instance;
function *api($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_apiOverride();
  var tmp0_elvis_lhs = yield* await_0(this_0, $completion);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = get_selectedApi();
    tmp = (yield* await_0(this_1, $completion)).get_api_18j9e7_k$();
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp.get_anonymousSurvey_8r5uiq_k$();
}
function *takerId($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_storedTakerId();
  var tmp0_safe_receiver = yield* await_0(this_0, $completion);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = Companion_getInstance().parse_pc1q8p_k$(tmp0_safe_receiver);
  }
  var tmp1_elvis_lhs = tmp;
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    // Inline function 'kotlin.also' call
    var this_1 = Companion_getInstance().random_fimq0t_k$();
    yield* get_storedTakerId().set_revjhg_k$(this_1.toString(), $completion);
    tmp_0 = this_1;
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  return tmp_0;
}
var StageClass;
function Stage() {
  if (StageClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'Stage');
    StageClass = $;
  }
  return StageClass;
}
function AnonymousSurveyPage$render$slambda(this$0) {
  return constructCallableReference(($this$rememberSuspending, $completion) => orPromise($completion, function *($completion) {
    return yield* (yield* /*#__NOINLINE__*/api(this$0, $completion)).getAnonymousSurvey_3d3sl6_k$(this$0.id_1, this$0.employer_1, $completion);
  }), 1);
}
function AnonymousSurveyPage$render$slambda_0(this$0) {
  return constructCallableReference(($this$rememberSuspending, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = this$0.reload_1;
    yield* await_0(this_0, $completion);
    return yield* (yield* /*#__NOINLINE__*/api(this$0, $completion)).getAnonymousTaking_kg5uas_k$(this$0.id_1, this$0.employer_1, yield* /*#__NOINLINE__*/takerId(this$0, $completion), $completion);
  }), 1);
}
function AnonymousSurveyPage$render$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_surveyLanguageLabel_fcb89_k$();
}
function AnonymousSurveyPage$render$lambda_0(it) {
  var tmp;
  switch (it.ordinal_1) {
    case 0:
    case 1:
      tmp = 'English';
      break;
    case 2:
      tmp = 'Espa\xF1ol';
      break;
    case 3:
      tmp = 'Portugu\xEAs';
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function AnonymousSurveyPage$render$lambda_1($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_surveyCompletedText_anx46t_k$();
}
function AnonymousSurveyPage$render$lambda_2($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_surveyTakeAgainButton_c6h420_k$();
}
function AnonymousSurveyPage$render$slambda_1(this$0) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    yield* this$0.retaking_1.set_revjhg_k$(true, $completion);
    return Unit_instance;
  }), 0);
}
function AnonymousSurveyPage$render$lambda_3($level) {
  return (it) => equals(it, $level);
}
function AnonymousSurveyPage$render$lambda_4($level) {
  return (old, it) => it ? $level : old;
}
function AnonymousSurveyPage$render$lambda_5($level) {
  return ($this$invoke) => {
    var strings = $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance()));
    var tmp;
    switch ($level.ordinal_1) {
      case 0:
        tmp = strings.get_surveyLeadershipManagesNoOne_4fq5q9_k$();
        break;
      case 1:
        tmp = strings.get_surveyLeadershipManagesEmployees_jcz2fz_k$();
        break;
      case 2:
        tmp = strings.get_surveyLeadershipManagesManagers_3jp6do_k$();
        break;
      case 3:
        tmp = strings.get_surveyLeadershipSeniorLeader_he8vsv_k$();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  };
}
function AnonymousSurveyPage$render$lambda_6($option) {
  return (it) => equals(it, $option);
}
function AnonymousSurveyPage$render$lambda_7($option) {
  return (old, it) => it ? $option : old;
}
function AnonymousSurveyPage$render$lambda_8($option) {
  return ($this$invoke) => {
    var tmp0_safe_receiver = $option;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.displayName_1;
    return tmp1_elvis_lhs == null ? $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_familyPreferNotToSayLabel_t7jcq_k$() : tmp1_elvis_lhs;
  };
}
function AnonymousSurveyPage$render$lambda_9($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_surveyContinueButton_w6kl50_k$();
}
function AnonymousSurveyPage$render$slambda_2(this$0) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    var tmp = yield* /*#__NOINLINE__*/api(this$0, $completion);
    var tmp_0 = yield* /*#__NOINLINE__*/takerId(this$0, $completion);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = this$0.leadershipLevel_1;
    var tmp$ret$0 = yield* await_0(this_0, $completion);
    var tmp_1 = ensureNotNull(tmp$ret$0);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = this$0.income_1;
    var tmp$ret$1 = yield* await_0(this_1, $completion);
    yield* tmp.startAnonymousTaking_ouul51_k$(this$0.id_1, this$0.employer_1, new (AnonymousStart())(tmp_0, tmp_1, tmp$ret$1), $completion);
    yield* this$0.retaking_1.set_revjhg_k$(false, $completion);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = this$0.reload_1;
    var tmp$ret$2 = yield* await_0(this_2, $completion);
    yield* this$0.reload_1.set_revjhg_k$(tmp$ret$2 + 1 | 0, $completion);
    return Unit_instance;
  }), 1);
}
function AnonymousSurveyPage$render$lambda$lambda($next, $saved, this$0) {
  return ($this$swap) => {
    var destruct = $next;
    var survey = destruct.component1_7eebsc_k$();
    var translate = destruct.component2_7eebsb_k$();
    surveyBody($this$swap, survey, $saved, this$0.drafts_1, (it) => new (QuestionResponse())(VOID, this$0.id_1, it._id_1, survey.audience_1, Companion_getInstance().NIL_1), translate);
    return Unit_instance;
  };
}
function AnonymousSurveyPage$render$lambda_10($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_surveyTakeSubmitButton_gkww0k_k$();
}
function AnonymousSurveyPage$render$slambda_3($loaded, $saved, this$0, $$this$button) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $loaded;
    var tmp = (yield* await_1(this_0, $completion)).survey_1;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = $saved;
    var tmp_0 = yield* await_1(this_1, $completion);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = this$0.drafts_1;
    var tmp$ret$2 = yield* await_0(this_2, $completion);
    var toSend = answersToSubmit(tmp, tmp_0, tmp$ret$2);
    var tmp_1;
    if (toSend.isEmpty_y1axqb_k$()) {
      var tmp_2 = $$this$button.get_context_h02k06_k$();
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_3 = get_strings(AppState_getInstance());
      var tmp$ret$3 = yield* await_0(this_3, $completion);
      toast(tmp_2, tmp$ret$3.get_surveyTakeNeedAnswerToast_561g7r_k$());
      return Unit_instance;
    }
    yield* (yield* /*#__NOINLINE__*/api(this$0, $completion)).answerAnonymousSurvey_8qah3o_k$(this$0.id_1, this$0.employer_1, new (AnonymousAnswers())(yield* /*#__NOINLINE__*/takerId(this$0, $completion), toSend), $completion);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_4 = $loaded;
    var tmp_3 = (yield* await_1(this_4, $completion)).survey_1;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_5 = $saved;
    var tmp_4 = yield* await_1(this_5, $completion);
    // Inline function 'kotlin.collections.associateBy' call
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(toSend, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity);
    var _iterator__ex2g4s = toSend.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      var tmp$ret$8 = new (ID())(element.question_1);
      destination.put_4fpzoq_k$(tmp$ret$8, element);
    }
    var nowComplete = isComplete(tmp_3, plus(tmp_4, destination));
    // Inline function 'kotlin.collections.mapOf' call
    var tmp$ret$9 = emptyMap();
    yield* this$0.drafts_1.set_revjhg_k$(tmp$ret$9, $completion);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_6 = this$0.reload_1;
    var tmp$ret$10 = yield* await_0(this_6, $completion);
    yield* this$0.reload_1.set_revjhg_k$(tmp$ret$10 + 1 | 0, $completion);
    var tmp_5 = $$this$button.get_context_h02k06_k$();
    var tmp_6;
    if (nowComplete) {
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_7 = get_strings(AppState_getInstance());
      tmp_6 = (yield* await_0(this_7, $completion)).get_surveyTakeThanksToast_6r9hqk_k$();
    } else {
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_8 = get_strings(AppState_getInstance());
      tmp_6 = (yield* await_0(this_8, $completion)).get_surveyTakeSavedToast_evm8s6_k$();
    }
    toast(tmp_5, tmp_6);
    return Unit_instance;
  }), 1);
}
function AnonymousSurveyPage$render$lambda_11($this$shownWhen) {
  return get_current(Companion_instance).equals(Platform_Web_getInstance());
}
function Stage_Opening_getInstance() {
  static_init();
  return Stage_Opening_instance;
}
function Stage_Questions_getInstance() {
  static_init();
  return Stage_Questions_instance;
}
function Stage_Completed_getInstance() {
  static_init();
  return Stage_Completed_instance;
}
var AnonymousSurveyPageClass;
function AnonymousSurveyPage() {
  if (AnonymousSurveyPageClass === VOID) {
    class $ {
      constructor(id, employer) {
        this.id_1 = id;
        this.employer_1 = employer;
        var tmp = this;
        // Inline function 'kotlin.collections.mapOf' call
        var tmp$ret$0 = emptyMap();
        tmp.drafts_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(tmp$ret$0);
        this.retaking_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(false);
        this.leadershipLevel_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(null);
        this.income_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(null);
        this.reload_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(0);
      }
      get_title_iz32un_k$() {
        return new (Constant())(_Constant___init__impl__v45mub('Survey'));
      }
      render_w3x9d1_k$(_this__u8e3s4) {
        // Inline function 'org.thecommunitygroupinc.cares.views.components.page' call
        var this_0 = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_1 = maxWidth(this_0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element);
        this_1.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        element.set_themeBase_daz04n_k$(Companion_getInstance_0().fromParentNonCascading_1);
        var loaded = rememberSuspending(VOID, VOID, VOID, AnonymousSurveyPage$render$slambda(this));
        var taking = rememberSuspending(VOID, VOID, VOID, AnonymousSurveyPage$render$slambda_0(this));
        var translate = remember(VOID, VOID, VOID, VOID, ($this$remember) => textFor($this$remember.invoke_r7m7el_k$(loaded).survey_1, get_language($this$remember.invoke_r7m7el_k$(get_strings(AppState_getInstance()))), $this$remember.invoke_r7m7el_k$(loaded).employerName_1));
        var open = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp0_safe_receiver = $this$remember.invoke_r7m7el_k$(taking).progress_1;
          var tmp;
          if (tmp0_safe_receiver == null) {
            tmp = null;
          } else {
            // Inline function 'kotlin.takeIf' call
            var tmp_0;
            if (tmp0_safe_receiver.completedAt_1 == null) {
              tmp_0 = tmp0_safe_receiver;
            } else {
              tmp_0 = null;
            }
            tmp = tmp_0;
          }
          return tmp;
        });
        var completedAt = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp0_safe_receiver = $this$remember.invoke_r7m7el_k$(taking).progress_1;
          return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.completedAt_1;
        });
        var saved = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp;
          if ($this$remember.invoke_r7m7el_k$(open) == null) {
            // Inline function 'kotlin.collections.mapOf' call
            tmp = emptyMap();
          } else {
            // Inline function 'kotlin.collections.associateBy' call
            var this_0 = $this$remember.invoke_r7m7el_k$(taking).answers_1;
            var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
            // Inline function 'kotlin.collections.associateByTo' call
            var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity);
            var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
            while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
              var element = _iterator__ex2g4s.next_20eer_k$();
              var tmp$ret$11 = new (ID())(element.question_1);
              destination.put_4fpzoq_k$(tmp$ret$11, element);
            }
            tmp = destination;
          }
          return tmp;
        });
        var stage = remember(VOID, VOID, VOID, VOID, ($this$remember) => !($this$remember.invoke_r7m7el_k$(open) == null) ? Stage_Questions_getInstance() : !($this$remember.invoke_r7m7el_k$(completedAt) == null) && !$this$remember.invoke_r7m7el_k$(this.retaking_1) ? Stage_Completed_getInstance() : Stage_Opening_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        element.willAddChild_hz2iwc_k$(element_0);
        element_0.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_2 = get_centered(element_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.h1' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_3 = weight(this_2, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (TextView())(this_3.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        this_3.willAddChild_hz2iwc_k$(element_1);
        element_1.set_themeChoice_py59um_k$(element_1.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H1Semantic())));
        var tmp = KMutableProperty0();
        var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_1);
        var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_1));
        element_1.invoke_bnq13k_k$(tmp_1, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(translate)($this$invoke.invoke_r7m7el_k$(loaded).survey_1.name_1));
        element_1.onStartup_vrxh3i_k$();
        this_3.addChild_2qpft2_k$(element_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_4 = get_centered(element_0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (RowOrCol())(this_4.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        this_4.willAddChild_hz2iwc_k$(element_2);
        element_2.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_3 = new (TextView())(element_2.get_context_h02k06_k$());
        ensureOutermostElement(element_3);
        element_2.willAddChild_hz2iwc_k$(element_3);
        element_3.set_themeChoice_py59um_k$(element_3.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
        var tmp_2 = KMutableProperty0();
        var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_3);
        var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_3));
        element_3.invoke_bnq13k_k$(tmp_4, AnonymousSurveyPage$render$lambda);
        element_3.onStartup_vrxh3i_k$();
        element_2.addChild_2qpft2_k$(element_3);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        // Inline function 'com.lightningkite.kiteui.views.direct.select' call
        var this_5 = themed(element_2, FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_4 = new (Select())(this_5.get_context_h02k06_k$());
        ensureOutermostElement(element_4);
        this_5.willAddChild_hz2iwc_k$(element_4);
        var tmp_5 = get_strings(AppState_getInstance());
        var tmp_6 = _Constant___init__impl__v45mub(listOf_0([StringsForLanguage_English_getInstance(), StringsForLanguage_Spanish_getInstance(), StringsForLanguage_Portuguese_getInstance()]));
        element_4.bind_64a41i_k$(tmp_5, new (Constant())(tmp_6), AnonymousSurveyPage$render$lambda_0);
        element_4.onStartup_vrxh3i_k$();
        this_5.addChild_2qpft2_k$(element_4);
        element_2.onStartup_vrxh3i_k$();
        this_4.addChild_2qpft2_k$(element_2);
        element_0.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_6 = shownWhen(element, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(stage).equals(Stage_Completed_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_5 = new (RowOrCol())(this_6.get_context_h02k06_k$());
        ensureOutermostElement(element_5);
        this_6.willAddChild_hz2iwc_k$(element_5);
        element_5.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_6 = new (TextView())(element_5.get_context_h02k06_k$());
        ensureOutermostElement(element_6);
        element_5.willAddChild_hz2iwc_k$(element_6);
        var tmp_7 = KMutableProperty0();
        var tmp_8 = TextView$_get_content_$ref_4pzcwl(element_6);
        var tmp_9 = getPropertyCallableRef('content', 0, tmp_7, tmp_8, TextView$_set_content_$ref_pketfb(element_6));
        element_6.invoke_bnq13k_k$(tmp_9, AnonymousSurveyPage$render$lambda_1);
        element_6.onStartup_vrxh3i_k$();
        element_5.addChild_2qpft2_k$(element_6);
        // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
        var this_7 = shownWhen(element_5, VOID, VOID, ($this$shownWhen) => {
          var tmp0_safe_receiver = $this$shownWhen.invoke_r7m7el_k$(completedAt);
          var tmp;
          if (tmp0_safe_receiver == null) {
            tmp = null;
          } else {
            // Inline function 'kotlin.let' call
            tmp = nextTakingDate($this$shownWhen.invoke_r7m7el_k$(loaded).survey_1, tmp0_safe_receiver);
          }
          var tmp1_safe_receiver = tmp;
          var tmp_0;
          if (tmp1_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.let' call
            tmp_0 = tmp1_safe_receiver.compareTo_e7gwgq_k$(today()) <= 0;
          }
          return tmp_0 === true;
        });
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        var this_8 = themed(this_7, ButtonSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_7 = new (Button())(this_8.get_context_h02k06_k$());
        ensureOutermostElement(element_7);
        this_8.willAddChild_hz2iwc_k$(element_7);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_8 = new (TextView())(element_7.get_context_h02k06_k$());
        ensureOutermostElement(element_8);
        element_7.willAddChild_hz2iwc_k$(element_8);
        var tmp_10 = KMutableProperty0();
        var tmp_11 = TextView$_get_content_$ref_4pzcwl(element_8);
        var tmp_12 = getPropertyCallableRef('content', 0, tmp_10, tmp_11, TextView$_set_content_$ref_pketfb(element_8));
        element_8.invoke_bnq13k_k$(tmp_12, AnonymousSurveyPage$render$lambda_2);
        element_8.onStartup_vrxh3i_k$();
        element_7.addChild_2qpft2_k$(element_8);
        onClick(element_7, VOID, VOID, VOID, AnonymousSurveyPage$render$slambda_1(this));
        element_7.onStartup_vrxh3i_k$();
        this_8.addChild_2qpft2_k$(element_7);
        element_5.onStartup_vrxh3i_k$();
        this_6.addChild_2qpft2_k$(element_5);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_9 = shownWhen(element, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(stage).equals(Stage_Opening_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_9 = new (RowOrCol())(this_9.get_context_h02k06_k$());
        ensureOutermostElement(element_9);
        this_9.willAddChild_hz2iwc_k$(element_9);
        element_9.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.card' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_10 = themed(element_9, CardSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_10 = new (RowOrCol())(this_10.get_context_h02k06_k$());
        ensureOutermostElement(element_10);
        this_10.willAddChild_hz2iwc_k$(element_10);
        element_10.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_11 = get_bold(element_10);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_11 = new (TextView())(this_11.get_context_h02k06_k$());
        ensureOutermostElement(element_11);
        this_11.willAddChild_hz2iwc_k$(element_11);
        var tmp_13 = KMutableProperty0();
        var tmp_14 = TextView$_get_content_$ref_4pzcwl(element_11);
        var tmp_15 = getPropertyCallableRef('content', 0, tmp_13, tmp_14, TextView$_set_content_$ref_pketfb(element_11));
        element_11.invoke_bnq13k_k$(tmp_15, ($this$invoke) => replace($this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_surveyLeadershipQuestion_pd6bg2_k$(), '[company]', $this$invoke.invoke_r7m7el_k$(loaded).employerName_1));
        element_11.onStartup_vrxh3i_k$();
        this_11.addChild_2qpft2_k$(element_11);
        var _iterator__ex2g4s = get_entries().iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var level = _iterator__ex2g4s.next_20eer_k$();
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_12 = new (RowOrCol())(element_10.get_context_h02k06_k$());
          ensureOutermostElement(element_12);
          element_10.willAddChild_hz2iwc_k$(element_12);
          element_12.set_vertical_nuap32_k$(false);
          // Inline function 'com.lightningkite.kiteui.views.direct.radioButton' call
          var this_12 = get_centered(element_12);
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_13 = new (RadioButton())(this_12.get_context_h02k06_k$());
          ensureOutermostElement(element_13);
          this_12.willAddChild_hz2iwc_k$(element_13);
          var tmp_16 = AnonymousSurveyPage$render$lambda_3(level);
          element_13.bind_gesskf_k$(element_13.checked_1, this.leadershipLevel_1.lens_u4wb4z_k$(tmp_16, AnonymousSurveyPage$render$lambda_4(level)));
          element_13.onStartup_vrxh3i_k$();
          this_12.addChild_2qpft2_k$(element_13);
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          var this_13 = get_centered(element_12);
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_14 = new (TextView())(this_13.get_context_h02k06_k$());
          ensureOutermostElement(element_14);
          this_13.willAddChild_hz2iwc_k$(element_14);
          var tmp_17 = KMutableProperty0();
          var tmp_18 = TextView$_get_content_$ref_4pzcwl(element_14);
          var tmp_19 = getPropertyCallableRef('content', 0, tmp_17, tmp_18, TextView$_set_content_$ref_pketfb(element_14));
          element_14.invoke_bnq13k_k$(tmp_19, AnonymousSurveyPage$render$lambda_5(level));
          element_14.onStartup_vrxh3i_k$();
          this_13.addChild_2qpft2_k$(element_14);
          element_12.onStartup_vrxh3i_k$();
          element_10.addChild_2qpft2_k$(element_12);
        }
        element_10.onStartup_vrxh3i_k$();
        this_10.addChild_2qpft2_k$(element_10);
        // Inline function 'com.lightningkite.kiteui.views.card' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_14 = themed(element_9, CardSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_15 = new (RowOrCol())(this_14.get_context_h02k06_k$());
        ensureOutermostElement(element_15);
        this_14.willAddChild_hz2iwc_k$(element_15);
        element_15.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_15 = get_bold(element_15);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_16 = new (TextView())(this_15.get_context_h02k06_k$());
        ensureOutermostElement(element_16);
        this_15.willAddChild_hz2iwc_k$(element_16);
        var tmp_20 = KMutableProperty0();
        var tmp_21 = TextView$_get_content_$ref_4pzcwl(element_16);
        var tmp_22 = getPropertyCallableRef('content', 0, tmp_20, tmp_21, TextView$_set_content_$ref_pketfb(element_16));
        element_16.invoke_bnq13k_k$(tmp_22, ($this$invoke) => replace($this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_surveyIncomeQuestion_em6voy_k$(), '[company]', $this$invoke.invoke_r7m7el_k$(loaded).employerName_1));
        element_16.onStartup_vrxh3i_k$();
        this_15.addChild_2qpft2_k$(element_16);
        var _iterator__ex2g4s_0 = plus_0(listOf(null), get_entries_0()).iterator_jk1svi_k$();
        while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
          var option = _iterator__ex2g4s_0.next_20eer_k$();
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_17 = new (RowOrCol())(element_15.get_context_h02k06_k$());
          ensureOutermostElement(element_17);
          element_15.willAddChild_hz2iwc_k$(element_17);
          element_17.set_vertical_nuap32_k$(false);
          // Inline function 'com.lightningkite.kiteui.views.direct.radioButton' call
          var this_16 = get_centered(element_17);
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_18 = new (RadioButton())(this_16.get_context_h02k06_k$());
          ensureOutermostElement(element_18);
          this_16.willAddChild_hz2iwc_k$(element_18);
          var tmp_23 = AnonymousSurveyPage$render$lambda_6(option);
          element_18.bind_gesskf_k$(element_18.checked_1, this.income_1.lens_u4wb4z_k$(tmp_23, AnonymousSurveyPage$render$lambda_7(option)));
          element_18.onStartup_vrxh3i_k$();
          this_16.addChild_2qpft2_k$(element_18);
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          var this_17 = get_centered(element_17);
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_19 = new (TextView())(this_17.get_context_h02k06_k$());
          ensureOutermostElement(element_19);
          this_17.willAddChild_hz2iwc_k$(element_19);
          var tmp_24 = KMutableProperty0();
          var tmp_25 = TextView$_get_content_$ref_4pzcwl(element_19);
          var tmp_26 = getPropertyCallableRef('content', 0, tmp_24, tmp_25, TextView$_set_content_$ref_pketfb(element_19));
          element_19.invoke_bnq13k_k$(tmp_26, AnonymousSurveyPage$render$lambda_8(option));
          element_19.onStartup_vrxh3i_k$();
          this_17.addChild_2qpft2_k$(element_19);
          element_17.onStartup_vrxh3i_k$();
          element_15.addChild_2qpft2_k$(element_17);
        }
        element_15.onStartup_vrxh3i_k$();
        this_14.addChild_2qpft2_k$(element_15);
        // Inline function 'com.lightningkite.kiteui.views.important' call
        var this_18 = get_atEnd(element_9);
        // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
        var this_19 = themed(this_18, ImportantSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        var this_20 = themed(this_19, ButtonSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_20 = new (Button())(this_20.get_context_h02k06_k$());
        ensureOutermostElement(element_20);
        this_20.willAddChild_hz2iwc_k$(element_20);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_21 = new (TextView())(element_20.get_context_h02k06_k$());
        ensureOutermostElement(element_21);
        element_20.willAddChild_hz2iwc_k$(element_21);
        var tmp_27 = KMutableProperty0();
        var tmp_28 = TextView$_get_content_$ref_4pzcwl(element_21);
        var tmp_29 = getPropertyCallableRef('content', 0, tmp_27, tmp_28, TextView$_set_content_$ref_pketfb(element_21));
        element_21.invoke_bnq13k_k$(tmp_29, AnonymousSurveyPage$render$lambda_9);
        element_21.onStartup_vrxh3i_k$();
        element_20.addChild_2qpft2_k$(element_21);
        var tmp_30 = KMutableProperty0();
        var tmp_31 = Button$_get_enabled_$ref_61t7nx(element_20);
        var tmp_32 = getPropertyCallableRef('enabled', 0, tmp_30, tmp_31, Button$_set_enabled_$ref_o8kynz(element_20));
        element_20.invoke_bnq13k_k$(tmp_32, ($this$invoke) => !($this$invoke.invoke_r7m7el_k$(this.leadershipLevel_1) == null));
        element_20.set_action_2ds022_k$(Action('Start survey', VOID, VOID, VOID, VOID, VOID, AnonymousSurveyPage$render$slambda_2(this)));
        element_20.onStartup_vrxh3i_k$();
        this_20.addChild_2qpft2_k$(element_20);
        element_9.onStartup_vrxh3i_k$();
        this_9.addChild_2qpft2_k$(element_9);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_21 = shownWhen(element, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(stage).equals(Stage_Questions_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_22 = new (RowOrCol())(this_21.get_context_h02k06_k$());
        ensureOutermostElement(element_22);
        this_21.willAddChild_hz2iwc_k$(element_22);
        element_22.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.swapping' call
        // Inline function 'com.lightningkite.kiteui.views.direct.swapView' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_23 = new (SwapView())(element_22.get_context_h02k06_k$());
        ensureOutermostElement(element_23);
        element_22.willAddChild_hz2iwc_k$(element_23);
        // Inline function 'com.lightningkite.kiteui.views.direct.swapping' call
        var this_22 = element_23;
        var queue = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        var alreadySwapping = {_v: false};
        reactive(this_22, 8, ($this$reactive) => {
          var c = to($this$reactive.invoke_r7m7el_k$(loaded).survey_1, $this$reactive.invoke_r7m7el_k$(translate));
          queue.add_utx5q5_k$(c);
          var tmp;
          if (alreadySwapping._v) {
            return Unit_instance;
          }
          alreadySwapping._v = true;
          $l$loop: while (true) {
            // Inline function 'kotlin.collections.isNotEmpty' call
            if (!!queue.isEmpty_y1axqb_k$()) {
              break $l$loop;
            }
            var next = queue.removeAt_6niowx_k$(0);
            try {
              var tmp_0 = Companion_getInstance_1().Fade_1;
              this_22.swap_26x94b_k$(tmp_0, AnonymousSurveyPage$render$lambda$lambda(next, saved, this));
            } catch ($p) {
              if ($p instanceof Exception()) {
                var e = $p;
                report(Exception().new_kotlin_Exception_9qyiel_k$('Failed to render ' + toString(next), e), 'SwapView.swapping');
              } else {
                throw $p;
              }
            }
          }
          alreadySwapping._v = false;
          return Unit_instance;
        });
        element_23.onStartup_vrxh3i_k$();
        element_22.addChild_2qpft2_k$(element_23);
        // Inline function 'com.lightningkite.kiteui.views.important' call
        var this_23 = get_atEnd(element_22);
        // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
        var this_24 = themed(this_23, ImportantSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        var this_25 = themed(this_24, ButtonSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_24 = new (Button())(this_25.get_context_h02k06_k$());
        ensureOutermostElement(element_24);
        this_25.willAddChild_hz2iwc_k$(element_24);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_25 = new (TextView())(element_24.get_context_h02k06_k$());
        ensureOutermostElement(element_25);
        element_24.willAddChild_hz2iwc_k$(element_25);
        var tmp_33 = KMutableProperty0();
        var tmp_34 = TextView$_get_content_$ref_4pzcwl(element_25);
        var tmp_35 = getPropertyCallableRef('content', 0, tmp_33, tmp_34, TextView$_set_content_$ref_pketfb(element_25));
        element_25.invoke_bnq13k_k$(tmp_35, AnonymousSurveyPage$render$lambda_10);
        element_25.onStartup_vrxh3i_k$();
        element_24.addChild_2qpft2_k$(element_25);
        element_24.set_action_2ds022_k$(Action('Submit answers', VOID, VOID, VOID, VOID, VOID, AnonymousSurveyPage$render$slambda_3(loaded, saved, this, element_24)));
        element_24.onStartup_vrxh3i_k$();
        this_25.addChild_2qpft2_k$(element_24);
        element_22.onStartup_vrxh3i_k$();
        this_21.addChild_2qpft2_k$(element_22);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        var this_26 = shownWhen(element, VOID, VOID, AnonymousSurveyPage$render$lambda_11);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_26 = new (Space())(this_26.get_context_h02k06_k$(), 1.0);
        ensureOutermostElement(element_26);
        this_26.willAddChild_hz2iwc_k$(element_26);
        element_26.onStartup_vrxh3i_k$();
        this_26.addChild_2qpft2_k$(element_26);
        element.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element);
        return Unit_instance;
      }
    }
    initMetadataForClass($, 'AnonymousSurveyPage', VOID, VOID, [Page(), FullscreenPage()], [0]);
    AnonymousSurveyPageClass = $;
  }
  return AnonymousSurveyPageClass;
}
var properties_initialized_AnonymousSurveyPage_kt_2e2a6e;
function _init_properties_AnonymousSurveyPage_kt__6juo4k() {
  if (!properties_initialized_AnonymousSurveyPage_kt_2e2a6e) {
    properties_initialized_AnonymousSurveyPage_kt_2e2a6e = true;
    // Inline function 'com.lightningkite.kiteui.reactive.PersistentProperty' call
    var key = 'surveyTakerId';
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_0 = serializer(createKType(PrimitiveClasses_getInstance().get_stringClass_bik2gy_k$(), arrayOf([]), true));
    var tmp$ret$1 = isInterface(this_0, KSerializer()) ? this_0 : THROW_CCE();
    storedTakerId = PersistentProperty().new_com_lightningkite_kiteui_reactive_PersistentProperty_dblk10_k$(key, null, tmp$ret$1);
  }
}
//region block: exports
export {
  AnonymousSurveyPage as AnonymousSurveyPage31h992m9jks1x,
};
//endregion

//# sourceMappingURL=AnonymousSurveyPage.mjs.map
